import { ContactView } from "./Shared/ContactView";
import { NavbarView } from "./Shared/NavbarView";

var contactView = new ContactView();
var navbarView = new NavbarView();


// WEBPACK FOOTER //
// ./www/js/Pages/Shared.ts